import { createRoutine } from "../utils/routine.utils";
export var getPartnerships = createRoutine("PARTNERSHIPS_GET");
export var requestLocationDescription = createRoutine("PARTNERSHIPS_REQUEST_LOCATION_DESCRIPTION");
